import { ReactComponent as Service } from 'assets/service.svg'
import { selectChatThreads } from 'containers/Chats/chatSlice'
import BigCircleBtn from 'components/buttons/BigCircleBtn'
import Notifications from 'containers/Help/Notifications'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Faq from 'containers/Help/Faq'
import { v7 } from 'uuid'
import './style.scss'

const Help = () => {
  const threads = useSelector(selectChatThreads)
  const { t } = useTranslation('help')
  const { push } = useHistory()

  const { active, inactive } = Object.values(threads).reduce((r, e) => {
    if (e.closed_at) r.inactive += 1
    else r.active += 1
    return r
  }, { active: 0, inactive: 0 })

  return (
    <div className='desktopHelp'>
      <div className='title'>
        <div>{t('technicalSupport')}</div>
        <div className='group'>
          <span>{t('howCanWeHelp')}</span>
        </div>
      </div>
      <div className="desktopHelp__wrap">
        <div className="desktopHelp__sidebar">
          <Service />
          <BigCircleBtn
            text={t('contact')}
            action={() => push(`/chat/${v7()}`)}
          />
        </div>
        <div className="desktopHelp__content">
          <div className="wrapper">
            <Faq />
          </div>
          {((active || inactive) !== 0) && <div className="wrapper">
            <Notifications />
          </div>}
        </div>
      </div>
    </div >
  )
}

export default Help